function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*------------------------------------------------------------------
YouTube & Vimeo embedder
------------------------------------------------------------------*/
var VideoController = /*#__PURE__*/function () {
  function VideoController(url) {
    var _this = this;
    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, VideoController);
    // The iframe element
    this.iframe = document.createElement('iframe');
    // Extract the video data
    this.video = this.parseURL(url);
    // The video source
    this.src = this.video.type === 'youtube' ? "https://www.youtube.com/embed/".concat(this.video.id, "?") : "https://player.vimeo.com/video/".concat(this.video.id, "?");

    // User settings / defaults
    this.settings = {
      modestbranding: 1,
      autoplay: 1,
      rel: 0
    };

    // The iframe attributes
    this.attributes = {
      allow: 'autoplay; encrypted-media',
      frameborder: 0,
      allowfullscreen: true,
      mozallowfullscreen: true,
      webkitallowfullscreen: true
    };

    // Object assign settings
    for (var key in parameters) {
      if (parameters.hasOwnProperty(key)) this.settings[key] = parameters[key];
    }

    // Object assign settings
    for (var _key in attributes) {
      if (attributes.hasOwnProperty(_key)) this.attributes[_key] = attributes[_key];
    }

    // Add the video parameters to the source
    for (var _key2 in this.settings) {
      if (_typeof(this.settings[_key2]) !== 'object') {
        if (this.settings[_key2] === 1 && _key2 === 'loop') this.src += "playlist=".concat(this.video.id, "&");
        this.src += "".concat(_key2, "=").concat(this.settings[_key2], "&");
      }
    }

    // Set the source
    this.iframe.src = this.src;
    // Add the attributes
    for (var _key3 in this.attributes) this.iframe.setAttribute(_key3, this.attributes[_key3]);
    // Tell us when it is loaded
    this.iframe.addEventListener('load', function () {
      return _this.iframe.className = 'video-loaded';
    });
  }
  _createClass(VideoController, [{
    key: "parseURL",
    value: function parseURL(url) {
      url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
      return {
        type: RegExp.$3.indexOf('youtu') > -1 ? 'youtube' : 'vimeo',
        id: RegExp.$6
      };
    }
  }]);
  return VideoController;
}(); // let videoEmbed = new Embed('https://www.youtube.com/watch?v=dbB-mICjkQM', { autoplay: 0 });
// $body.append(videoEmbed.render());
export { VideoController as default };